module.exports = __webpack_public_path__ + "static/media/YF97_3.4504967e.jpg";